import { LiveCallService } from "../../_service/live-call-service";
import { LiveCall } from "../../types/live-call/live-call.type";

export default async function joinLiveCall(liveCall: LiveCall) {
    try {
        const meetingUrl = await LiveCallService.createCallLink(liveCall.meetingId);
        if (meetingUrl) {
          window.open(meetingUrl, "_blank");
        }
      } catch (error: any) {
        console.error("Error joining meeting:", error.message);
      }
}
